import { Api } from './api';
import type { IBankScrapingManager, INextExecution } from '../types';

export class BankScrapingManagerApi extends Api {

  static async getLast() {
    return this.get<IBankScrapingManager>('/bank-scraping-manager/last');
  }

  static async getNextExcecution() {
    return this.get<INextExecution>('/bank-scraping-manager/next-execution');
  }
}
